import subDays from 'date-fns/sub_days'
import format from 'date-fns/format'

export function getDefaultInterval() {
  let dates = {}
  dates.to = format(new Date(), 'YYYY-MM-DD')
  dates.from = filterDateQueryFormat(subDays(new Date(), 30))
  return dates
}

export function filterDateQueryFormat(date) {
  return format(date, 'YYYY-MM-DD')
}
